import React from 'react'
import { Table, Message } from 'antd'
import {
  getBatchDetail,
  getSaleJournalDetail,
} from '../../../api/businessCommodity'
import { QqSquareFilled } from '@ant-design/icons'
import { batch } from 'react-redux'

export default class extends React.Component {
  state = {
    batchList: [],
    tableLoading: false,
  }

  componentDidMount() {
    if (this.props.tableStatus == 'details') {
      // const { listingId, id } = this.props.record
      // this.getBatchList(listingId, id)
    }

    if (this.props.tableStatus == 'records') {
      // this.props.openMultiTable()
    }
  }

  getBatchList = async (listingId, id) => {
    this.setState({ tableLoading: true })
    const { data, status, detail } = await getBatchDetail(listingId, id)
    if (status == 1) {
      this.setState({
        batchList: data,
        tableLoading: false,
      })
    } else {
      Message.error(detail)
      this.setState({ tableLoading: false })
    }
  }

  getSaleList = async (expanded, record) => {
    if (expanded) {
      this.setState({ tableLoading: true })
      const { data, status, detail } = await getSaleJournalDetail(record.saleId)
      if (status == 1) {
        this.setState({
          batchList: data,
          tableLoading: false,
        })
      } else {
        Message.error(detail)
        this.setState({ tableLoading: false })
      }
    }
  }

  render() {
    const { batchList } = this.props
    if (!batchList || batchList.length == 0) {
      return <div></div>
    }
    return this.state.tableLoading ? null : (
      <Table
        bordered
        columns={this.props.batchColumns}
        dataSource={this.props.batchList}
        pagination={true}
        rowKey={(record, index) => index}
        onRow={(record, index) => {
          if (this.props.onRowclick) {
            return {
              onClick: () => {
                this.props.onRowclick(record, index)
              },
            }
          } else {
            return
          }
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/multiTable.js